import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-callback',
  template: '',
})
export class CallbackComponent implements OnInit {
  private _exceptionalURLs: string[] = [
    '/callback',
    '/login',
    '/create-account',
    '/unsuccessful-login',
    '/test-browser-error',
    '/passwordChangedCallback',
    '/members',
  ];
  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    let redirect_uri = this.route.snapshot.queryParams['redirect_uri'] ?? '/home';
    this.router.navigateByUrl(this.getNavigationRoute(redirect_uri));
  }

  private getNavigationRoute(redirect_uri: string): string {
    if (redirect_uri) {
      let check = this._exceptionalURLs
        .map((url) => redirect_uri.startsWith(url))
        .find((x) => x == true);
      return check ? '/home' : redirect_uri;
    } else {
      return '/home';
    }
  }
}
